<template>

    <div class="nepal-payment">
      <div class="bank-list-body">
        <div class="form-banner">
          <div class="banner-overlay" :style="bgStyle">></div>
          <div class="banner-content-wrap">
            <div class="banner-logo">
              <img src="@/assets/images/logo-nepal-payment-normal.png" alt="" />
            </div>
          </div>
        </div>
        <div class="nepalpay-form-body">
          <div class="body-container">
            <Loader v-if="!isDataLoaded" class="nepPayLoder" />

            <div class="form-body-content" v-else>
              <div class="form-body-header">
                <div class="btn-wrap">
                  <v-btn text @click="goBack">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Cancel
                  </v-btn>
                </div>
                <div class="search-box">
                  <v-text-field
                    v-model="search"
                    label="Search for banks"
                    clearable
                    outlined
                    rounded
                    height="50"
                    append-icon="search"
                  ></v-text-field>
                </div>
              </div>
              <div class="nepay-body">
                <div class="bank-list-wrapper row">
                   <div class="col-md-6">
                    <div class="bank-list-card">
                      <div class="list-card-title">
                        <h6>Mobile Banking</h6>
                      </div>
                      <perfect-scrollbar>
                        <ul class="bank-list">
                          <template v-for="(bank, index) in filteredList">
                            <li
                              :key="index"
                              v-if="bank.BankType === 'MBanking'"
                            >
                              <div
                                @click="bankSelected(bank, index)"
                                class="bank-info"
                                :class="{ loading: loading }"
                              >
                                <div class="bank-logo-wrap">
                                  <img
                                    :src="bank.LogoUrl"
                                    :alt="bank.InstitutionName"
                                  />
                                </div>
                                <div class="logo-title">
                                  {{ bank.InstitutionName }}
                                </div>
                                <div
                                  class="loading-circular-overlay"
                                  v-if="selectedIndex === index"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="red"
                                  ></v-progress-circular>
                                </div>
                              </div>
                            </li>
                          </template>
                        </ul>
                      </perfect-scrollbar>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="bank-list-card">
                      <div class="list-card-title">
                        <h6>Internet Banking </h6>
                      </div>
                      <perfect-scrollbar>
                        <ul class="bank-list">
                          <template v-for="(bank, index) in filteredList">
                            <li
                              :key="index"
                              v-if="bank.BankType === 'EBanking'"
                            >
                              <div
                                @click="bankSelected(bank, index)"
                                class="bank-info"
                                :class="{ loading: loading }"
                              >
                                <div class="bank-logo-wrap">
                                  <img
                                    :src="bank.LogoUrl"
                                    :alt="bank.InstitutionName"
                                  />
                                </div>
                                <div class="logo-title">
                                  {{ bank.InstitutionName }}
                                </div>
                                <div
                                  class="loading-circular-overlay"
                                  v-if="selectedIndex === index"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="red"
                                  ></v-progress-circular>
                                </div>
                              </div>
                            </li>
                          </template>
                        </ul>
                      </perfect-scrollbar>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>

        <form
          ngNoForm
          ref="nepalPayForm"
          id="nepalPayForm"
          v-if="showPostForm"
          :action="postUrl"
          method="post"
        >
          <div v-for="(value, name) in formInputs" :key="name">
            <input type="hidden" :id="name" :name="name" :value="value" />
          </div>
        </form>
      </div>
    </div>

</template>
<script>
import Promise from "../../lib/mixins/ExtendedPromises";
import Payment from "../../repositories/payment";
import Loader from "../../components/Loader";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
export default {
  name: "NepalPay",
  mixins: [Promise],
  components: {
    Loader,
    PerfectScrollbar
  },

  data() {
    return {
      selectedIndex: null,
      bgStyle: {
        backgroundImage: `url(${require("@/assets/images/hero_area_bg1.jpg")})`
      },
      isDataLoaded: false,
      mode: "NEPAL_PAYMENT",
      hash: "",
      allBankLists: [],
      bankLists: {
        eBanking: [],
        mBanking: []
      },
      postUrl: "",
      formInputs: [],
      showPostForm: false,
      search: "",
      loading: false
    };
  },
  computed: {
    filteredList() {
      return this.allBankLists.filter(bank => {
        return bank.InstitutionName.toLowerCase().includes(
          this.search.toLowerCase()
        );
      });
    }
  },
  mounted() {
    this.hash = this.$route.params.id;
    const operation = this.response(Payment.getAllBankLists(this.hash));
    operation
      .then(response => {
        if (operation.isFulfilled()) {
          this.allBankLists = response.data.data;
          this.bankLists.eBanking = this.allBankLists.filter(
            bank => bank.BankType === "EBanking"
          );
          this.bankLists.mBanking = this.allBankLists.filter(
            bank => bank.BankType === "MBanking"
          );
        }
        this.isDataLoaded = true;
      })
      .catch(err => {
        this.$toasted.show(err.data.message, {
          type: "error"
        });
        this.isDataLoaded = true;
      });
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    bankSelected(bank, index) {
      this.loading = true;
      this.selectedIndex = index;
      this.showPostForm = false;
      let payload = {
        paymentHashMap: {
          InstrumentCode: bank.InstrumentCode
        }
      };

      const operation = this.response(
        Payment.postPayment(this.hash, this.mode, payload)
      );
      operation
        .then(response => {
          this.loading = false;
          this.selectedIndex = null;
          let responseData = response.data;
          if (operation.isFulfilled()) {
            this.postUrl = responseData.redirectionUrl;
            this.formInputs = responseData.paymentHashMap;
            this.showPostForm = true;
            setTimeout(() => {
              this.$refs["nepalPayForm"].submit();
            }, 300);
          }
        })
        .catch(err => {
          this.loading = false;
          this.selectedIndex = null;
          this.showPostForm = false;
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    margin-right: -12px;
    margin-left: -12px;
}
.col-md-6{
    width: 100%;
    padding: 12px;
}
@media only screen and (max-width: 960px) {
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
<style>
/*
 * Container style
 */
 .ps {
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}
/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear;
  -webkit-transition: background-color .2s linear, opacity .2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0px;
  /* please don't change 'position' */
  position: absolute;
}
.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear;
  -webkit-transition: background-color .2s linear, opacity .2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
}
.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}
.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}
.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: #eee;
  opacity: 0.9;
}
/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color .2s linear, height .2s ease-in-out;
  -webkit-transition: background-color .2s linear, height .2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}
.ps__thumb-y {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color .2s linear, width .2s ease-in-out;
  -webkit-transition: background-color .2s linear, width .2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}
.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
  background-color: #999;
  height: 11px;
}
.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #999;
  width: 11px;
}
/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.ps {
    position: relative;
}

</style>
<!-- <style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" /> -->
